import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import ExerciseForm from "../../components/forms/ExerciseForm";
import BasePage from "../common/BasePage";

type Params = {
  lessonId: string;
};

export default function NewExercisePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const { lessonId } = useParams<Params>();
  const onSuccess = useCallback(
    (createdExerciseId: number) => {
      navigate(`../${createdExerciseId}`);
      toast({
        title: t("new_exercise_page.exercise_created"),
        description: t("new_exercise_page.exercise_created_message"),
        status: "success",
        isClosable: true,
      });
    },
    [navigate, t, toast],
  );

  const onError = useCallback(() => {
    toast({
      title: t("new_exercise_page.exercise_error"),
      description: t("new_exercise_page.exercise_error_message"),
      status: "error",
      isClosable: true,
    });
  }, [t, toast]);

  return (
    <BasePage title={t("new_exercise_page.new_exercise")}>
      <ExerciseForm
        lessonId={lessonId}
        onSuccess={onSuccess}
        onError={onError}
      />
    </BasePage>
  );
}
